module.exports = __webpack_public_path__ + "img/app-store-icon.1f4e1559.svg";